import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import useSectionManager from "../hooks/useSectionManager";
import { useMenuHandler } from "../hooks/useMenuHandler";
import { clickHandler } from "../utils/clickHandler";

export const Navigation = () => {
  const [isImageVisible, setImageVisible] = useState(false);
  const activeSection = useSectionManager();
  const navbarRef = useRef(null);

  // Функция для закрытия меню
  const closeMenu = () => {
    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse && navbarCollapse.classList.contains("in")) {
      navbarCollapse.classList.remove("in");
    }
  };

  useEffect(() => {
    setImageVisible(true);
  }, []);

  useMenuHandler(navbarRef, closeMenu);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top" ref={navbarRef}>
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Навигация</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <CSSTransition in={isImageVisible} timeout={500} classNames="pulse" unmountOnExit>
            <img src={process.env.PUBLIC_URL + "/static/img/logo.webp"} alt="Логотип «LiftBlesk»" />
          </CSSTransition>
          <a className="navbar-brand page-scroll" href="/" onClick={(e) => clickHandler(e, "")}>
            Lift Blesk
          </a>
          <div className="telephone">
            <p>
              <a href="tel:+79216546574" title="Позвонить (доступно только для мобильных устройств)">
                +7 (921) 654-65-74
              </a>
            </p>
          </div>
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            {[
              { id: "about-us", label: "О нас" },
              { id: "metal-restoration-services", label: "Услуги" },
              { id: "restoration-portfolio", label: "Портфолио" },
              { id: "customer-reviews", label: "Отзывы" },
              { id: "contacts", label: "Контакты" },
            ].map(({ id, label }) => (
              <li key={id} className={activeSection === id ? "active" : ""}>
                <a href={`/${id}`} onClick={(e) => clickHandler(e, id)}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
